import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import AboutBannerImg from '../assets/images/sell-banner.png';
import ArrowIcon from '../assets/images/button-arrow.svg';
import { AGENTS_PORTAL } from '../api/constants';
import { Link } from 'react-router-dom';
const BecomeAgentBanner = () => {
   return (
    <section className="about-banner-section">
        <Row>
          <Col lg={6} md={12} className='about-content-box align-self-center'>
            <div className="about-content">
              <h1 className="about-title">
              Create your <span>real estate</span><br/> agent profile
              </h1>
              <p className="about-description">
              Showcase your expertise to active home shoppers in your market. A free Real Estate agent profile helps you build your brand on Real Estate and Trulia.
              </p>
              <Link to={`${AGENTS_PORTAL}/auth/register`} target="_blank" className='custom-bttn style-3 ani-1 right'>
                Signup Now <img src={ArrowIcon} alt="Arrow Icon" />
              </Link>

            </div>
          </Col>
          <Col lg={6} md={12}>
            <div className="about-image">
              <img 
                src={AboutBannerImg}
                alt="Modern House" 
                className="house-img"
              />
            </div>
          </Col>
        </Row>
    </section>
  );
}

export default BecomeAgentBanner;